import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomTimpickerComponent } from './custom-timpicker.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [CustomTimpickerComponent],
  imports: [CommonModule, FormsModule],
  exports: [CustomTimpickerComponent],
})
export class CustomTimpickerModule {}
